import React from 'react';
import { Box, Text, Textarea } from '@chakra-ui/react';

const TextOutputPanel = ({ value, labelId }) => (
  <Box display="flex" flexDirection="column" minH={{ base: '220px', md: '360px' }} flex={1}>
    <Text fontSize="sm" fontWeight="700" color="gray.700" mb={2}>
      Cleaned output
    </Text>
    <Textarea
      id={labelId}
      value={value}
      readOnly
      flex={1}
      minH={{ base: '200px', md: '320px' }}
      resize="vertical"
      borderRadius="xl"
      borderColor="teal.100"
      bg="teal.50"
      fontSize="sm"
      lineHeight="tall"
      color="gray.800"
      _focus={{ boxShadow: 'outline' }}
      aria-label="Cleaned text output"
    />
  </Box>
);

export default TextOutputPanel;
